const isInViewport = function ( elem ) {
	const bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
		bounding.right <= ( window.innerWidth || document.documentElement.clientWidth )
	);
};

/**
 * Check if the pin is in the viewport. If so, add the attribute to animate it.
 *
 * @param {NodeList} pins The elements that match.
 */
function checkPins( pins ) {
	pins.forEach( pin => {
		if ( isInViewport( pin ) ) {
			pin.setAttribute( 'data-bounce-in', 'data-bounce-in' );
		}
	} );
}

function checkShakes( shakers ) {
	shakers.forEach( shaker => {
		if ( isInViewport( shaker ) ) {
			shaker.setAttribute( 'data-shake', 'data-shake' );
			removeShake();
		}
	} );
}

const checkWheel = ( wheel ) => {
	if ( isInViewport( wheel ) ) {
		wheel.setAttribute( 'data-spin', 'spin' );
		// removeShake();
	}
}

function removeShake() {

	const shakes = document.querySelectorAll( '[data-shake]' );

	if ( shakes ) {
		shakes.forEach( shake => {
			shake.addEventListener( 'click', ( e ) => {
				shake.removeAttribute( 'data-shake' );
			} );
			shake.addEventListener( 'mousedown', ( e ) => {
				shake.removeAttribute( 'data-shake' );
			} );
		} );
	}

}

/**
 * Setup any pins that are on the page.
 */
// eslint-disable-next-line consistent-return
function setupPins() {
	const pins = document.querySelectorAll( '[data-drop-pin]' );

	if ( ! pins ) {
		return false;
	}

	checkPins( pins );

	document.addEventListener( 'scroll', () => {
		checkPins( pins );
	} );

}

// eslint-disable-next-line consistent-return
function setupShake() {
	const shakers = document.querySelectorAll( '[data-shake-entrance]' );

	if ( ! shakers ) {
		return false;
	}

	checkShakes( shakers );

	document.addEventListener( 'scroll', () => {
		checkShakes( shakers );
	} );

}

const setupWheel = () => {
	const wheel = document.querySelector( '#outer-buttons' );

	if ( ! wheel ) return false;

	checkWheel( wheel );

	document.addEventListener( 'scroll', () => checkWheel( wheel ) );

	return true;

}

window.addEventListener( 'load', () => {
	setupPins();
	setupShake();
	setupWheel();
} );
